import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useUserContext } from "../Context/UserContext";

/**
 * Always-on notice when Django SHOW_SAAS_PAYMENT_DUE_BANNER is enabled.
 * Only staff / superusers receive show_saas_payment_due_banner=true from
 * /current/user — clients never see this banner.
 */
export default function SaasPaymentDueBanner() {
  const [user] = useUserContext();
  if (!user?.show_saas_payment_due_banner) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 px-4 py-3 shadow-sm"
    >
      <div className="flex items-start gap-3">
        <ExclamationCircleOutlined className="mt-0.5 shrink-0 text-lg text-amber-700" />
        <div className="min-w-0 flex-1">
          <p className="m-0 text-sm font-bold leading-snug text-amber-950 sm:text-base">
            Cloud SaaS subscription payment is due. Please make payment to continue
            portal services without interruption.
          </p>
          <p className="m-0 mt-1 text-[11px] font-medium uppercase tracking-wide text-amber-800/80">
            Staff only — this notice is not shown to clients
          </p>
        </div>
      </div>
    </div>
  );
}
